<script>
    import { classNames,uuid } from "../../utils";
    let cls = "sui-step";
    export let title = "";
    /*
    'wait' | 'process' | 'finish' | 'error'
    */
    export let status = "wait";
</script>

<div
    class={classNames({
        [cls]: cls,
        [`${cls}-${status}`]: status,
    })}
>
    <div class={`${cls}-indicator`}>
        <div class={`${cls}-icon-container`}>
            <slot name="icon">
                <span class={`${cls}-icon-dot`} />
            </slot>
        </div>
    </div>
    <div class={`${cls}-content`}>
        <h4 class={`${cls}-title`}>{title}</h4>
        <p class={`${cls}-desc`}>
            <slot />
        </p>
    </div>
</div>

<style lang="less">
    @import "./steps.less";
</style>
